/**
 * 数据库表名常量
 * 独立文件，避免与 Supabase 客户端初始化耦合
 */
export const TABLES = {
  projects: 'projects',
  user_profiles: 'user_profiles',
} as const;

